import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=542aca56&scoped=true&"
import script from "./DebugPanel.vue?vue&type=script&lang=ts&"
export * from "./DebugPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DebugPanel.vue?vue&type=style&index=0&id=542aca56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542aca56",
  null
  
)

export default component.exports